import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';

type Result = {
	amount: number;
	minAmount: number;
	maxAmount: number;
};

export function useEnforceMembershipAmount(): () => Result {
	const { amountFromBaseUnits } = useI18n();
	const [{ amount: originalAmount }] = usePromotePageState();
	const {
		data: {
			currency,
			featureConfigs: { subscriptionConfiguration },
		},
	} = usePromotePageData();

	return function enforceMembershipAmount(): Result {
		let subscriptionMaxAmount = Number.MAX_SAFE_INTEGER;
		let subscriptionMinAmount = 0;
		let amount = originalAmount;
		if (subscriptionConfiguration) {
			subscriptionMinAmount = amountFromBaseUnits(subscriptionConfiguration.minAmount, currency.code);
			subscriptionMaxAmount = amountFromBaseUnits(subscriptionConfiguration.maxAmount, currency.code);
			if (subscriptionMinAmount > amount) {
				amount = subscriptionMinAmount;
			} else if (amount > subscriptionMaxAmount) {
				amount = subscriptionMaxAmount;
			}
		}
		return {
			amount,
			minAmount: subscriptionMinAmount,
			maxAmount: subscriptionMaxAmount,
		};
	};
}
